import React from "react";
import { Box } from "@material-ui/core";
import _ from "lodash";
import { getOptions, color } from "highcharts";
import { useTheme } from "@material-ui/core/styles";

import ChartStockBase from "components/visuals/ChartStockBase";

const data1 = [[1580913000000,80],[1580999400000,81],[1581085800000,83],[1581172200000,82],[1581258600000,80],[1581345000000,80],[1581431400000,84],[1581517800000,89],[1581604200000,93],[1581690600000,97],[1581777000000,100],[1581863400000,100],[1581949800000,97],[1582036200000,102],[1582122600000,106],[1582209000000,111],[1582295400000,110],[1582381800000,116],[1582468200000,114],[1582554600000,119],[1582641000000,122],[1582727400000,122],[1582813800000,124],[1582900200000,123],[1582986600000,124],[1583073000000,124],[1583159400000,121],[1583245800000,124],[1583332200000,124],[1583418600000,127],[1583505000000,124],[1583591400000,123],[1583677800000,120],[1583764200000,123],[1583850600000,124],[1583937000000,123],[1584023400000,119],[1584109800000,122],[1584196200000,121],[1584282600000,120],[1584369000000,124],[1584455400000,122],[1584541800000,126],[1584628200000,123],[1584714600000,122],[1584801000000,121],[1584887400000,120],[1584973800000,122],[1585060200000,126],[1585146600000,130],[1585233000000,134],[1585319400000,134],[1585405800000,134],[1585492200000,134],[1585578600000,132],[1585665000000,128],[1585751400000,125],[1585837800000,126],[1585924200000,125],[1586010600000,125],[1586097000000,130],[1586183400000,132],[1586269800000,132],[1586356200000,128],[1586442600000,130],[1586529000000,135],[1586615400000,140],[1586701800000,142],[1586788200000,142],[1586874600000,146],[1586961000000,144],[1587047400000,150],[1587133800000,152],[1587220200000,152],[1587306600000,150],[1587393000000,153],[1587479400000,150],[1587565800000,153],[1587652200000,156],[1587738600000,160],[1587825000000,159],[1587911400000,155],[1587997800000,156],[1588084200000,161],[1588170600000,160],[1588257000000,157],[1588343400000,161],[1588429800000,162],[1588516200000,166],[1588602600000,170],[1588689000000,171],[1588775400000,176],[1588861800000,174],[1588948200000,176],[1589034600000,175],[1589121000000,179],[1589207400000,182],[1589293800000,185],[1589380200000,188],[1589466600000,187]];


const data2 = [[1580913000000,80],[1580999400000,81],[1581085800000,86],[1581172200000,86],[1581258600000,84],[1581345000000,84],[1581431400000,87],[1581517800000,83],[1581604200000,81],[1581690600000,83],[1581777000000,79],[1581863400000,79],[1581949800000,81],[1582036200000,78],[1582122600000,82],[1582209000000,81],[1582295400000,85],[1582381800000,87],[1582468200000,92],[1582554600000,88],[1582641000000,92],[1582727400000,96],[1582813800000,100],[1582900200000,98],[1582986600000,101],[1583073000000,106],[1583159400000,103],[1583245800000,99],[1583332200000,101],[1583418600000,107],[1583505000000,104],[1583591400000,103],[1583677800000,108],[1583764200000,105],[1583850600000,101],[1583937000000,107],[1584023400000,111],[1584109800000,112],[1584196200000,110],[1584282600000,107],[1584369000000,112],[1584455400000,116],[1584541800000,116],[1584628200000,119],[1584714600000,124],[1584801000000,126],[1584887400000,123],[1584973800000,123],[1585060200000,127],[1585146600000,129],[1585233000000,134],[1585319400000,135],[1585405800000,131],[1585492200000,136],[1585578600000,135],[1585665000000,131],[1585751400000,137],[1585837800000,135],[1585924200000,134],[1586010600000,136],[1586097000000,136],[1586183400000,141],[1586269800000,141],[1586356200000,145],[1586442600000,142],[1586529000000,142],[1586615400000,144],[1586701800000,143],[1586788200000,147],[1586874600000,146],[1586961000000,143],[1587047400000,145],[1587133800000,146],[1587220200000,146],[1587306600000,151],[1587393000000,155],[1587479400000,155],[1587565800000,157],[1587652200000,162],[1587738600000,159],[1587825000000,159],[1587911400000,163],[1587997800000,163],[1588084200000,165],[1588170600000,171],[1588257000000,172],[1588343400000,176],[1588429800000,181],[1588516200000,181],[1588602600000,185],[1588689000000,186],[1588775400000,188],[1588861800000,191],[1588948200000,188],[1589034600000,194],[1589121000000,191],[1589207400000,188],[1589293800000,184],[1589380200000,186],[1589466600000,187]];


const DualAxisStock = () => {
    const theme = useTheme();

    const yAxisStandardOptions = {
        gridLineWidth: 1,
        minorGridLineWidth: 0,
        gridLineColor: '#646174',
        opposite: false,
        labels: {
            style: {
                color: theme.palette.common.white
            },
            align: 'right',
            x: -3
        },
        title: {
            style: {
                color: theme.palette.common.white
            }
        },
        resize: {
            enabled: true
        }
    };

    const globalOptions = {
        lang: {
            rangeSelectorZoom: 'Zoom'
        }
    };

    const options = {
        yAxis: [_.merge({}, yAxisStandardOptions, {
            height: '60%'
        }),
        _.merge({}, yAxisStandardOptions, {
            top: "65%",
            height: "35%",
            endOnTick: false
        })
        ],
        tooltip: {
            split: true
        },
        series: [
            {
                type: 'spline',
                name: 'Dairy revenue',
                yAxis: 0,
                data: data1
            },
            {
                type: 'column',
                name: 'Dairy unit sales',
                yAxis: 1,
                data: data2
            }
        ],
        xAxis: {
            dateTimeLabelFormats: {
                millisecond: '%e %b %Y',
                second: '%e %b %Y',
                minute: '%e %b %Y',
                hour: '%e %b %Y',
                day: '%e %b %Y',
                week: '%b %Y',
                month: '%b %Y',
                year: '%Y'
            }
        },
        navigator: {
            series: {
                dataLabels : {
                    color: "white"
                },
                color: '#42E8E0',
                //lineWidth: '3px',
                
                fillColor: {
                 linearGradient: [0, 0, 0, 300],
                 stops: [
                    [0, color(getOptions().colors[0]).setOpacity(0.4).get('rgba')],
                    [1, color(getOptions().colors[0]).setOpacity(0.1).get('rgba')]
                 ]
                }
            },
            xAxis: {
                dateTimeLabelFormats: {
                    year: '%Y'
                },
                labels: {
                    formatter: function() {
                    },
                    y: 25,
                    style:{
                        color: 'white'
                    }
                }
               
            }
        },
        rangeSelector: {
            allButtonsEnabled: true,
            buttonSpacing: 10,
            selected: 4,
            buttonTheme: {
                fill: '#3A384F',
                stroke: 'none',
                'stroke-width': 0,
                fontFamily: 'Open Sans',
                r: 5,
                width: 50,
                style: {
                    color: '#FFFFFF'
                },
                states: {
                    hover: {
                        fill: '#1C76FD',
                        style: {
                            color: 'white',
                            fontWeight: 'bold',
                            fontFamily: 'Open Sans'
                        }
                    },
                    select: {
                        fill: '#42E8E0',
                        style: {
                            color: '#3A384F',
                            fontFamily: 'Open Sans'
                        }
                    }
                }
                
            },
            inputBoxBorderColor: '#3A384F',
            inputBoxWidth: 120,
            inputBoxHeight: 18,
            inputStyle: {
                color: 'gray',
                fontWeight: '',
                borderRadius: '6px'
            },
            labelStyle: {
                color: 'white',
            }
        }
    };

    return (
        <Box>
            <ChartStockBase options={options} globalOptions={globalOptions}/>
        </Box>
    );
};

export default DualAxisStock;
